import React, { FunctionComponent, ReactElement } from "react";
import PropTypes from "prop-types";
import Zero from "./Items/Zero";
import Burger from "./Items/Burger";
import HotTub from "./Items/HotTub";
import Travel from "./Items/Travel";
import Robot from "./Items/Robot";
import TV from "./Items/TV";
import Water from "./Items/Water";
import BathroomRenovation from "./Items/BathroomRenovation";
import Car from "./Items/Car";

interface IGraphicsItemProps {
  income: number;
}

const GraphicsItem: FunctionComponent<IGraphicsItemProps> = ({ income }) => {
  let item: ReactElement;

  if (income === 0) item = <Zero />;
  if (income > 0) item = <Burger />;
  if (income > 2500) item = <HotTub />;
  if (income > 5000) item = <Travel />;
  if (income > 7500) item = <Robot />;
  if (income > 10000) item = <TV />;
  if (income > 12500) item = <Water />;
  if (income > 15000) item = <BathroomRenovation />;
  if (income >= 25000) item = <Car />;

  return item;
};

GraphicsItem.propTypes = {
  income: PropTypes.number,
};

GraphicsItem.defaultProps = {
  income: null,
};

export default GraphicsItem;
